import { Http } from '../../shared';
import { settings } from '../../settings';

export class ContentService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }


    async find(query) {
        var response = await this.http.get(`${this.service_url}/contents?${new URLSearchParams(query)}`);
        return response.data;
    }
}
